/* eslint-disable import/extensions */
import React from 'react';
import PropTypes from 'prop-types';
import StructureModel from '@Components/Results/structure/structure-model.service.js';
import StructureZoomService from '@Services/StructureZoom';
import ReactTargetHelper from '@Components/Results/services/react-target-helper.service';
import Structure from '@Components/Results/structure/Structure';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

export default class TargetMostActiveSubstanceComponent extends React.PureComponent {
  static formatStructure(structure, databaseId) {
    // eslint-disable-next-line no-param-reassign
    structure.databaseId = databaseId;
    return new StructureModel(structure);
  }

  constructor(props) {
    super(props);

    this.zoomClasses = StructureZoomService.getZoomClasses('tgitems') || [];
  }

  render() {
    const { metadata, target, zoom } = this.props;
    const substanceEntity = getValueByNs(target, 'mostActiveSubstanceDetails.substanceEntity');
    const { isTestedSample } = ReactTargetHelper;
    const zoomClass = this.zoomClasses[zoom];

    if (substanceEntity) {
      substanceEntity.databaseId = target.databaseId;
    }
    return (
      <div className="target-active-substance">
        <span className="target-active-substance-caption">{isTestedSample(target) ? 'Example structure' : 'Most active substance:'}</span>

        <div className={`substance-item ${zoomClass}`}>
          {target.mostActiveSubstanceDetails && (
            <Structure metadata={metadata} structure={this.constructor.formatStructure(substanceEntity, target.databaseId)} zoom={zoom} />
          )}
        </div>

        <span className={`target-active-substance-property substance-item ${zoomClass}`}>
          {isTestedSample(target) ? 'No quantitative value reported' : target.mostActiveValue}
        </span>
      </div>
    );
  }
}

TargetMostActiveSubstanceComponent.propTypes = {
  target: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  metadata: PropTypes.object,
};
